<template>
  <div class="p-expiration-item-panel">
    <div class="p-expiration-item-panel__body">
      <div class="p-expiration-item-panel__date">
        <span>{{ formated_date }}</span>
      </div>
      <div class="p-expiration-item-panel__heading">
        <p data-translate-skip>{{ detail }}</p>
      </div>
    </div>
    <div class="p-expiration-item-panel__status">
      <span v-if="status" class="p-h01-point-confirm-item__text">
        {{ status }}
      </span>
    </div>
    <div class="p-expiration-item-panel__type">
      <div class="p-h01-point-confirm-item__status__label">
        <TextLabel
          v-if="label"
          :color="{ border: customizeColor, content: '#ffffff' }"
          :reverse="false"
        >
          {{ label }}
        </TextLabel>
      </div>
    </div>
    <div class="p-expiration-item-panel__point">
      <PointNotation
        :icon-size="false"
        :point="point"
        :point_name="point_name"
        :sign-is-exists="false"
        :font-size="24"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import SmallText from "@/common/components/atoms/SmallText.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import TextLabel from "@/common/components/atoms/TextLabel.vue";

import commons from "@/common/store/modules/commons";
import { formatUTCDate } from "@/common/assets/js/utils/dateFormat";

@Options({
  props: {
    date: { type: String, required: true },
    detail: { type: String, required: true },
    status: { type: String, required: true },
    label: { type: String, required: true },
    point: { type: Number, required: true },
    point_name: { type: String, required: true }
  },
  components: {
    SmallText,
    PointNotation,
    TextLabel
  }
})
export default class ExpirationItemPanel extends Vue {
  date!: string;
  detail!: string;
  status!: string;
  label!: string;
  point!: number;
  point_name!: string;

  get customizeColor() {
    return commons?.colorCode;
  }

  get formated_date() {
    return formatUTCDate(this.date);
  }
}
</script>

<style lang="scss" scoped>
.p-expiration-item-panel {
  @include pc {
    display: flex;
    align-items: center;
    padding: rem(25) rem(16);
  }
  @include sp {
    display: grid;
    grid-template-columns: auto auto 1fr;
    grid-template-rows: auto auto auto;
    align-items: center;
    padding: rem(20) 0;
  }

  &__body {
    @include pc {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
    @include sp {
      display: contents;
    }
  }

  &__date {
    @include pc {
      min-width: rem(70);
    }
    @include sp {
      grid-column: 1 / 3;
      grid-row: 1;
    }
    font-size: $text-size__body--l;
    font-weight: bold;
  }

  &__heading {
    @include pc {
      margin-top: rem(4);
    }
    @include sp {
      grid-column: 1 / -1;
      grid-row: 3;
      margin-top: rem(4);
    }
    font-size: $text-size__body--l;
  }

  &__point {
    @include pc {
      margin-left: rem(16);
      width: rem(180);
      min-width: rem(180);
      display: flex;
      justify-content: flex-end;
    }
    @include sp {
      grid-column: 3;
      grid-row: 1;
      justify-self: end;
    }
  }

  &__type {
    @include large-pc {
      display: flex;
      margin-left: rem(8);
    }
    @include sp {
      grid-column: 2;
      grid-row: 2;
      margin-top: rem(4);
      margin-left: rem(8);
    }
    font-size: $text-size__body--l;
  }

  &__status {
    @include large-pc {
      display: flex;
      margin-left: rem(16);
    }
    @include sp {
      grid-column: 1;
      grid-row: 2;
      margin-top: rem(4);
    }
    font-size: $text-size__body--m;
    color: $common-gray500;
  }

  &__label {
    @include large-pc {
      margin: 0 0 0 rem(8);
    }
    @include large-sp {
      width: rem(78);
      min-height: rem(16);
      margin: rem(4) 0 0 auto;
    }
  }
}
</style>
